import { render, staticRenderFns } from "./ViewPhieuUpload.vue?vue&type=template&id=319b6dbb"
import script from "./ViewPhieuUpload.vue?vue&type=script&lang=js"
export * from "./ViewPhieuUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports